<template>
  <div>
    <!-- в пятницу было потрачено около 20 минут -->
    <BaseTopLine></BaseTopLine>
    <div
      class="tw-px-[26px] tw-bottom-[20px] tw-bg-bgPage tw-min-h-[calc(100vh-220px)]"
      v-if="loadStatus == 'success' && loadUserSetting"
    >
      <vue-tabs class="vue-tabs-type-1">
        <v-tab title="Реквизиты">
          <BaseLoader v-if="loadStatus == 'request'"></BaseLoader>
          <div
            class="tw-grid tw-grid-cols-[65%_auto] tw-gap-[15px] tw-pt-[15px]"
          >
            <div class="flex-1" v-if="userSetting">
              <div
                class="tw-text-[14px] tw-bg-danger tw-text-white tw-rounded-[6px] tw-px-[15px] tw-py-[10px] tw-mb-[15px] tw-cursor-pointer"
                v-if="
                  userSetting.company_status == 'company_status_not_requested'
                "
                @click="changeCompanyStatus"
              >
                Ваш профиль не подтвержден! <br />
                Недоступны: глобальная шахматка, создание открытых площадок,
                прием заказов от агрегаторов, вывод средств. <br />
                Подтвердите ИНН и нажмите эту кнопку
              </div>
              <div
                class="mb-10 fsc-16 text-dark fw-semi-bold bg-disabled p-15 text-center text-center"
                v-if="userSetting.company_status == 'company_status_rejected'"
                @click="changeCompanyStatus"
              >
                Ваш профиль отклонен модератором
              </div>
              <div
                class="mb-10 fsc-16 text-white fw-semi-bold bg-warning-state p-15 text-center text-center"
                v-if="userSetting.company_status == 'company_status_requested'"
                @click="changeCompanyStatus"
              >
                Ваш профиль на проверке модератором
              </div>

              <div
                class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
              >
                <!-- <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[15px]"
                  v-html="dataLang['reg_company_110']"
                ></div> -->
                <div class="tw-grid tw-grid-cols-3 tw-gap-[10px]">
                  <div>
                    <div
                      class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                    >
                      Публичный бренд (название для клиентов)
                    </div>
                    <BaseInput
                      inputClass="tw-app-input-type-3"
                      ref="company_settings__hours_at_day"
                      input-name="company_settings__hours_at_day"
                      :value="dataSettings.company_settings__hours_at_day"
                      @onInput="updateValue"
                    ></BaseInput>
                  </div>
                  <div>
                    <div
                      class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                    >
                      Регион главного офиса
                    </div>
                    <BaseSelect
                      class="multiselect-type-3"
                      selectLabel=""
                      deselectLabel=""
                      openDirection="bottom"
                      @input="
                        (data) =>
                          changeCityAndRegion({
                            companies__region_id: data.regions__id,
                          })
                      "
                      v-model="selectsValue.region"
                      :options="selectsData.region"
                      label="regions__name"
                    >
                      <template slot="noOptions">{{
                        dataLang["select_empty"]
                      }}</template>
                      <template slot="noResult">{{
                        dataLang["select_search_empty"]
                      }}</template
                      ><template slot="selectedLabel">{{
                        dataLang["select_selected"]
                      }}</template>
                      <template slot="deselectLabel">{{
                        dataLang["select_unselect"]
                      }}</template>
                    </BaseSelect>
                  </div>
                  <div>
                    <div
                      class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                    >
                      Город главного офиса
                    </div>
                    <BaseSelect
                      class="multiselect-type-3"
                      selectLabel=""
                      deselectLabel=""
                      openDirection="bottom"
                      @input="
                        (data) =>
                          changeCityAndRegion({
                            companies__city_id: data.cities__id,
                          })
                      "
                      v-model="selectsValue.cities"
                      :options="cityOptions"
                      label="cities__name"
                    >
                      <template slot="noOptions">{{
                        dataLang["select_empty"]
                      }}</template>
                      <template slot="noResult">{{
                        dataLang["select_search_empty"]
                      }}</template
                      ><template slot="selectedLabel">{{
                        dataLang["select_selected"]
                      }}</template>
                      <template slot="deselectLabel">{{
                        dataLang["select_unselect"]
                      }}</template>
                    </BaseSelect>
                  </div>
                </div>
              </div>

              <div
                class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
              >
                <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[15px]"
                >
                  {{ dataLang?.set_req_group1 }}
                </div>

                <div class="tw-mb-[15px]">
                  <div class="tw-app-input-type-3-label">
                    {{ dataLang?.company_settings__set_req_company_name }}
                  </div>
                  <BaseInput
                    inputClass="tw-app-input-type-3"
                    ref="company_settings__set_req_company_name"
                    input-name="company_settings__set_req_company_name"
                    :value="dataSettings.company_settings__set_req_company_name"
                    @onInput="updateValue"
                  ></BaseInput>
                </div>

                <div class="tw-mb-[15px]">
                  <div class="tw-app-input-type-3-label">
                    {{ dataLang?.company_settings__set_req_address_ur }}
                  </div>
                  <BaseInput
                    inputClass="tw-app-input-type-3"
                    ref="company_settings__set_req_address_ur"
                    input-name="company_settings__set_req_address_ur"
                    :value="dataSettings.company_settings__set_req_address_ur"
                    @onInput="updateValue"
                  ></BaseInput>
                </div>

                <div class="tw-mb-[15px]">
                  <div class="tw-app-input-type-3-label">
                    {{ dataLang?.company_settings__set_req_address_fact }}
                  </div>
                  <BaseInput
                    inputClass="tw-app-input-type-3"
                    ref="company_settings__set_req_address_fact"
                    input-name="company_settings__set_req_address_fact"
                    :value="dataSettings.company_settings__set_req_address_fact"
                    @onInput="updateValue"
                  ></BaseInput>
                </div>

                <div class="tw-mb-[15px]">
                  <div class="tw-app-input-type-3-label">
                    {{ dataLang?.company_settings__set_req_inn }}
                  </div>
                  <BaseInput
                    inputClass="tw-app-input-type-3"
                    ref="company_settings__set_req_inn"
                    input-name="company_settings__set_req_inn"
                    :value="dataSettings.company_settings__set_req_inn"
                    @onInput="updateValue"
                  ></BaseInput>

                  <div
                    class="tw-text-[12px] tw-text-danger tw-mt-[3px]"
                    v-if="
                      !settingsAreaWithInnConfirmed.companies__is_inn_confirmed
                    "
                  >
                    <!-- Подтвердите ИНН! Пополните баланс вашего лицевого счета
                    (желтая кнопка "плюс" сверху или 301 раздел) на любую сумму
                    (от 1 рубля) по безналичному расчету с юридического лица,
                    чей ИНН указан в этом поле. При поступлении средств, это
                    предупреждение исчезнет -->
                    {{ dataLang?.alert_text_79 || "Подтвердите ИНН!" }}
                  </div>
                </div>

                <div class="tw-mb-[15px]">
                  <div class="tw-app-input-type-3-label">
                    {{ dataLang?.company_settings__set_req_kpp }}
                  </div>
                  <BaseInput
                    inputClass="tw-app-input-type-3"
                    ref="company_settings__set_req_kpp"
                    input-name="company_settings__set_req_kpp"
                    :value="dataSettings.company_settings__set_req_kpp"
                    @onInput="updateValue"
                  ></BaseInput>
                </div>

                <div class="tw-mb-[15px]">
                  <div class="tw-app-input-type-3-label">
                    {{ dataLang?.company_settings__set_req_ogrn }}
                  </div>
                  <BaseInput
                    inputClass="tw-app-input-type-3"
                    ref="company_settings__set_req_ogrn"
                    input-name="company_settings__set_req_ogrn"
                    :value="dataSettings.company_settings__set_req_ogrn"
                    @onInput="updateValue"
                  ></BaseInput>
                </div>

                <div class="tw-mb-[15px]">
                  <div class="tw-app-input-type-3-label">
                    {{ dataLang?.company_settings__set_req_rs }}
                  </div>
                  <BaseInput
                    inputClass="tw-app-input-type-3"
                    ref="company_settings__set_req_rs"
                    input-name="company_settings__set_req_rs"
                    :value="dataSettings.company_settings__set_req_rs"
                    @onInput="updateValue"
                  ></BaseInput>
                </div>

                <div class="tw-mb-[15px]">
                  <div class="tw-app-input-type-3-label">
                    {{ dataLang?.company_settings__set_req_bank }}
                  </div>
                  <BaseInput
                    inputClass="tw-app-input-type-3"
                    ref="company_settings__set_req_bank"
                    input-name="company_settings__set_req_bank"
                    :value="dataSettings.company_settings__set_req_bank"
                    @onInput="updateValue"
                  ></BaseInput>
                </div>
                <!-- s -->
                <div class="tw-mb-[15px]">
                  <div class="tw-app-input-type-3-label">
                    {{ dataLang?.company_settings__set_req_bik }}
                  </div>
                  <BaseInput
                    inputClass="tw-app-input-type-3"
                    ref="company_settings__set_req_bik"
                    input-name="company_settings__set_req_bik"
                    :value="dataSettings.company_settings__set_req_bik"
                    @onInput="updateValue"
                  ></BaseInput>
                </div>

                <div class="tw-mb-[15px]">
                  <div class="tw-app-input-type-3-label">
                    {{ dataLang?.company_settings__set_req_ks }}
                  </div>
                  <BaseInput
                    inputClass="tw-app-input-type-3"
                    ref="company_settings__set_req_ks"
                    input-name="company_settings__set_req_ks"
                    :value="dataSettings.company_settings__set_req_ks"
                    @onInput="updateValue"
                  ></BaseInput>
                </div>

                <div class="tw-mb-[15px]">
                  <div class="tw-app-input-type-3-label">
                    {{ dataLang?.company_settings__set_req_phone }}
                  </div>
                  <BaseInput
                    inputClass="tw-app-input-type-3"
                    :placeholder="
                      dataSettings.company_settings__set_req_phone_mask
                    "
                    input-ref="company_settings__set_req_phone"
                    input-name="company_settings__set_req_phone"
                    :value="dataSettings.company_settings__set_req_phone"
                    @onInput="updateValue"
                    :max-length="16"
                    :input-mask="true"
                  >
                  </BaseInput>
                </div>

                <div class="tw-mb-[15px]">
                  <div class="tw-app-input-type-3-label">
                    {{ dataLang?.company_settings__set_req_email }}
                  </div>
                  <BaseInput
                    inputClass="tw-app-input-type-3"
                    ref="company_settings__set_req_email"
                    input-name="company_settings__set_req_email"
                    :value="dataSettings.company_settings__set_req_email"
                    @onInput="updateValue"
                  ></BaseInput>
                </div>

                <div class="tw-mb-[15px]">
                  <div class="tw-app-input-type-3-label">
                    {{ dataLang?.company_settings__set_req_gen_dir }}
                  </div>
                  <BaseInput
                    inputClass="tw-app-input-type-3"
                    ref="company_settings__set_req_gen_dir"
                    input-name="company_settings__set_req_gen_dir"
                    :value="dataSettings.company_settings__set_req_gen_dir"
                    @onInput="updateValue"
                  ></BaseInput>
                </div>
                <!-- <div class="mb-5">
                <BaseInput
                  placeholder=""
                  ref="company_settings__set_req_bik"
                  input-name="company_settings__set_req_gen_dir_rp"
                  :value="dataSettings.company_settings__set_req_gen_dir_rp"
                  @onInput="updateValue"
                  :name-sign="dataLang?.company_settings__set_req_gen_dir_rp"
                ></BaseInput>
              </div>
              <div class="mb-5">
                <BaseInput
                  placeholder=""
                  ref="company_settings__set_req_gen_dir_dp"
                  input-name="company_settings__set_req_gen_dir_dp"
                  :value="dataSettings.company_settings__set_req_gen_dir_dp"
                  @onInput="updateValue"
                  :name-sign="dataLang?.company_settings__set_req_gen_dir_dp"
                ></BaseInput>
              </div> -->

                <!-- <div class="mb-5">
                <BaseInput
                  placeholder=""

                  ref="company_settings__set_req_gen_dir_dp"
                  input-name="company_settings__set_req_wapp"
                  :value="dataSettings.company_settings__set_req_wapp"
                  @onInput="updateValue"
                  :name-sign="dataLang?.company_settings__set_req_wapp"
                ></BaseInput>
              </div>
              <div class="mb-5">
                <BaseInput
                  placeholder=""

                  ref="company_settings__set_req_gen_dir_dp"
                  input-name="company_settings__set_req_telegram"
                  :value="dataSettings.company_settings__set_req_telegram"
                  @onInput="updateValue"
                  :name-sign="dataLang?.company_settings__set_req_telegram"
                ></BaseInput>
              </div> -->
                <!-- <div class="mb-5">
                <BaseInput placeholder=""  ref="company_settings__set_req_gen_dir_dp"
                  input-name="company_settings__set_req_vladelets_sms"
                  :value="dataSettings.company_settings__set_req_vladelets_sms" @onInput="updateValue"
                  :name-sign="dataLang?.company_settings__set_req_vladelets_sms"></BaseInput>
              </div>
              <div class="mb-5">
                <BaseInput placeholder=""  ref="company_settings__set_req_gen_dir_dp"
                  input-name="company_settings__set_req_director_email"
                  :value="dataSettings.company_settings__set_req_director_email" @onInput="updateValue"
                  :name-sign="dataLang?.company_settings__set_req_director_email"></BaseInput>
              </div>
              <div class="mb-5">
                <BaseInput placeholder=""  ref="company_settings__set_req_gen_dir_dp"
                  input-name="company_settings__set_req_director_email"
                  :value="dataSettings.company_settings__set_req_director_sms" @onInput="updateValue"
                  :name-sign="dataLang?.company_settings__set_req_director_sms"></BaseInput>
              </div> -->
              </div>
            </div>
            <div class="">
              <div
                class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
              >
                <BaseCheckboxV2
                  signClass="!tw-text-[14px] !tw-text-forTitle"
                  ref="company_settings__is_active_email_subs"
                  input-name="company_settings__is_active_email_subs"
                  v-model="dataSettings.company_settings__is_active_email_subs"
                  @oncheckeds="updateValue"
                >
                  Получать важные новости от Сириус на e-mail из реквизитов
                </BaseCheckboxV2>
              </div>

              <div
                class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
              >
                <div
                  class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[15px]"
                >
                  {{ dataLang?.company_setting_3 }}
                </div>
                <!-- тестирование -->
                <div class="tw-columns-2">
                  <div
                    v-for="(item, index) in SeniorManagementReportsAndAlerts"
                    :key="index"
                    class="tw-mb-[15px] tw-break-inside-avoid"
                  >
                    <div class="tw-app-input-type-3-label">
                      {{ dataLang?.[item.title] || item.title }}
                    </div>
                    <BaseInput
                      inputClass="tw-app-input-type-3"
                      :input-name="item.value"
                      :value="dataSettings[item.value]"
                      @onInput="updateValue"
                    ></BaseInput>
                  </div>
                </div>
                <!-- тестирование -->
              </div>
              <div
                class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
              >
                <div>
                  <div class="multiselect-type-3-label">
                    Часовой пояс системы
                  </div>
                  <BaseSelect
                    class="multiselect-type-3"
                    :options="selectOptionsUTC()"
                    :custom-label="(elem) => 'UTC ' + elem"
                    placeholder=""
                    selectLabel=""
                    v-model="selectedOptionUTC"
                  >
                    <div slot="no-options">Пока нет опций</div>
                  </BaseSelect>
                </div>
                <!-- <div class="mb-5">
                  <BaseInput
                    placeholder=""

                    ref="company_settings__set_req_phone_mask"
                    input-name="company_settings__set_req_phone_mask"
                    :value="dataSettings.company_settings__set_req_phone_mask"
                    @onInput="updateValue"
                    name-sign="Телефонная маска системы"
                  ></BaseInput>
                </div> -->
              </div>

              <div
                class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
              >
                <div class="tw-mb-[20px]">
                  <div
                    class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                  >
                    Файл лого (PNG, прозрачный, размер 1000х1000 пикселей,
                    рисунок в границах)
                  </div>
                  <div>
                    <a
                      class="tw-text-[14px]"
                      :href="dataSettings.company_settings__set_doc_file_logo"
                      v-show="dataSettings.company_settings__set_doc_file_logo"
                      target="_blank"
                    >
                      {{ dataSettings.company_settings__set_doc_file_logo }}</a
                    >
                    <div class="tw-flex tw-gap-[10px]">
                      <label
                        class="tw-app-btn-primary"
                        :class="{
                          'tw-pointer-events-none tw-opacity-[0.5]':
                            dataSettings.company_settings__set_doc_file_logo,
                        }"
                      >
                        Добавить файл
                        <input
                          type="file"
                          class="d-none"
                          accept="image/png"
                          @change="
                            uploadFile(
                              $event,
                              'company_settings__set_doc_file_logo'
                            )
                          "
                          ref="company_settings__set_doc_file_logo"
                      /></label>
                      <button
                        class="tw-app-btn-primary-outline"
                        :class="{
                          disabled:
                            !dataSettings.company_settings__set_doc_file_logo,
                        }"
                        @click="delFile('company_settings__set_doc_file_logo')"
                      >
                        Удалить файл
                      </button>
                    </div>
                  </div>
                </div>
                <div class="tw-h-[1px] tw-bg-forLine tw-mb-[20px]"></div>
                <div class="tw-mb-[20px]">
                  <div
                    class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                  >
                    {{ dataLang?.company_settings__stamp_file_id }}
                  </div>
                  <div>
                    <a
                      class="tw-text-[14px]"
                      :href="dataSettings.company_settings__stamp_file_id"
                      v-show="dataSettings.company_settings__stamp_file_id"
                      target="_blank"
                    >
                      {{ dataSettings.company_settings__stamp_file_id }}</a
                    >
                    <div class="tw-flex tw-gap-[10px]">
                      <label
                        class="tw-app-btn-primary"
                        :class="{
                          'tw-pointer-events-none tw-opacity-[0.5]':
                            dataSettings.company_settings__stamp_file_id,
                        }"
                        >Добавить файл
                        <input
                          type="file"
                          class="d-none"
                          accept="image/png"
                          @change="
                            uploadFile(
                              $event,
                              'company_settings__stamp_file_id'
                            )
                          "
                          ref="stamp_file_id"
                      /></label>
                      <button
                        class="tw-app-btn-primary-outline"
                        :class="{
                          disabled:
                            !dataSettings.company_settings__stamp_file_id,
                        }"
                        @click="delFile('company_settings__stamp_file_id')"
                      >
                        Удалить файл
                      </button>
                    </div>
                  </div>
                </div>
                <div class="tw-h-[1px] tw-bg-forLine tw-mb-[20px]"></div>
                <div class="tw-mb-[20px]">
                  <div
                    class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                  >
                    {{ dataLang?.company_settings__stamp_sign_id }}
                  </div>
                  <div>
                    <a
                      class="tw-text-[14px]"
                      :href="dataSettings.company_settings__sign_file_id"
                      v-show="dataSettings.company_settings__sign_file_id"
                      target="_blank"
                    >
                      {{ dataSettings.company_settings__sign_file_id }}</a
                    >
                    <div class="tw-flex tw-gap-[10px]">
                      <label
                        class="tw-app-btn-primary"
                        :class="{
                          'tw-pointer-events-none tw-opacity-[0.5]':
                            dataSettings.company_settings__sign_file_id,
                        }"
                        >Добавить файл
                        <input
                          type="file"
                          class="d-none"
                          accept="image/png"
                          @change="
                            uploadFile($event, 'company_settings__sign_file_id')
                          "
                          ref="stamp_file_id"
                      /></label>
                      <button
                        class="tw-app-btn-primary-outline"
                        :class="{
                          disabled:
                            !dataSettings.company_settings__sign_file_id,
                        }"
                        @click="delFile('company_settings__sign_file_id')"
                      >
                        Удалить файл
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <div class="block-action mt-20">
                <span class="fw-bold">{{ dataLang?.set_req_group3 }}</span>
                <BaseInput placeholder=""  ref="company_settings__set_req_otzyv_yandex"
                input-name="company_settings__set_req_otzyv_yandex" :value="dataSettings.company_settings__set_req_otzyv_yandex" @onInput="updateValue"
                :name-sign="dataLang?.company_settings__set_req_otzyv_yandex"></BaseInput>
                <BaseInput placeholder=""  ref="company_settings__set_req_otzyv_google"
                input-name="company_settings__set_req_control_kach_sms" :value="dataSettings.company_settings__set_req_otzyv_google" @onInput="updateValue"
                :name-sign="dataLang?.company_settings__set_req_otzyv_google"></BaseInput>
                <BaseInput placeholder=""  ref="company_settings__set_req_otzyv_bonus"
                input-name="company_settings__set_req_control_kach_sms" :value="dataSettings.company_settings__set_req_otzyv_bonus" @onInput="updateValue"
                :name-sign="dataLang?.company_settings__set_req_otzyv_bonus"></BaseInput>
                <BaseCheckboxV2 placeholder=""  ref="company_settings__set_req_otzyv_uvedoml" class="mt-20"
                input-name="company_settings__set_req_otzyv_uvedoml" v-model="dataSettings.company_settings__set_req_otzyv_uvedoml" @oncheckeds="updateValue">
                  {{ dataLang?.company_settings__set_req_otzyv_uvedoml }}
                </BaseCheckboxV2> -->
              <!-- </div> -->
            </div>
          </div>
        </v-tab>

        <v-tab title="Договоры">
          <div class="tw-pt-[15px]">
            <div
              class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
            >
              <div>
                <div class="tw-mb-[20px]">
                  <div
                    class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                  >
                    Файл договора присоединения
                  </div>
                  <div>
                    <a
                      class="tw-text-[14px]"
                      :href="dataSettings.company_settings__set_doc_file_offer"
                      v-show="dataSettings.company_settings__set_doc_file_offer"
                      target="_blank"
                    >
                      {{ dataSettings.company_settings__set_doc_file_offer }}</a
                    >
                    <div class="tw-flex tw-gap-[10px]">
                      <label
                        class="tw-app-btn-primary"
                        :class="{
                          disabled:
                            dataSettings.company_settings__set_doc_file_offer,
                        }"
                        >Добавить файл
                        <input
                          type="file"
                          class="d-none"
                          @change="
                            uploadFile(
                              $event,
                              'company_settings__set_doc_file_offer'
                            )
                          "
                          ref="company_settings__set_doc_file_offer"
                      /></label>
                      <div
                        class="tw-app-btn-primary-outline"
                        :class="{
                          disabled:
                            !dataSettings.company_settings__set_doc_file_offer,
                        }"
                        @click="delFile('company_settings__set_doc_file_offer')"
                      >
                        Удалить файл
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="dataSettings.company_settings__set_doc_file_offer">
                  <ul class="list-style-none tw-text-[14px]">
                    <li
                      class="text-decoration-underline cursor-pointer"
                      @click="
                        () =>
                          onCopy(
                            dataSettings.company_settings__set_doc_file_offer
                          )
                      "
                    >
                      Скопируйте эту ссылку
                    </li>
                    <li>
                      Зайдите на
                      <a href="https://code-qr.ru/" target="_blank"
                        >https://code-qr.ru/</a
                      >
                    </li>
                    <li>
                      Вставьте ссылку в строчку и нажмите “Сгенерировать код”.
                      После, нажмите “Скачать файл PNG” (сохраните картинку
                      куда-нибудь)
                    </li>
                    <li>Полученную PNG картинку загрузите сюда:</li>
                  </ul>

                  <div class="tw-mb-[20px]">
                    <div
                      class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
                    >
                      Файл qrcode
                    </div>
                    <div>
                      <a
                        class="tw-text-[14px]"
                        :href="
                          dataSettings.company_settings__set_doc_file_qrcode
                        "
                        v-show="
                          dataSettings.company_settings__set_doc_file_qrcode
                        "
                        target="_blank"
                      >
                        {{
                          dataSettings.company_settings__set_doc_file_qrcode
                        }}</a
                      >
                      <div class="tw-flex tw-gap-[10px]">
                        <label
                          class="tw-app-btn-primary"
                          :class="{
                            disabled:
                              dataSettings.company_settings__set_doc_file_qrcode,
                          }"
                          >Добавить файл
                          <input
                            type="file"
                            class="d-none"
                            @change="
                              uploadFile(
                                $event,
                                'company_settings__set_doc_file_qrcode'
                              )
                            "
                            ref="company_settings__set_doc_file_qrcode"
                        /></label>
                        <div
                          class="tw-app-btn-primary-outline"
                          :class="{
                            disabled:
                              !dataSettings.company_settings__set_doc_file_qrcode,
                          }"
                          @click="
                            delFile('company_settings__set_doc_file_qrcode')
                          "
                        >
                          Удалить файл
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="mb-5 mt-40">
                <BaseInput
                  placeholder=""

                  ref="company_settings__set_doc_depozit"
                  input-name="company_settings__set_doc_depozit"
                  :value="dataSettings.company_settings__set_doc_depozit"
                  @onInput="updateValue"
                  :name-sign="dataLang?.company_settings__set_doc_depozit"
                ></BaseInput>
              </div>
              <div class="mb-5 mt-10">
                <BaseInput
                  placeholder=""

                  ref="company_settings__set_doc_depozit_back"
                  input-name="company_settings__set_doc_depozit_back"
                  :value="dataSettings.company_settings__set_doc_depozit_back"
                  @onInput="updateValue"
                  :name-sign="dataLang?.company_settings__set_doc_depozit_back"
                ></BaseInput>
              </div>
              <div class="mb-5 mt-10">
                <BaseInput
                  placeholder=""

                  ref="company_settings__set_doc_probeg"
                  input-name="company_settings__set_doc_probeg"
                  :value="dataSettings.company_settings__set_doc_probeg"
                  @onInput="updateValue"
                  :name-sign="dataLang?.company_settings__set_doc_probeg"
                ></BaseInput>
              </div>
              <div class="mb-5 mt-10">
                <BaseInput
                  placeholder=""

                  ref="company_settings__set_doc_toplivo_1l"
                  input-name="company_settings__set_doc_toplivo_1l"
                  :value="dataSettings.company_settings__set_doc_toplivo_1l"
                  @onInput="updateValue"
                  :name-sign="dataLang?.company_settings__set_doc_toplivo_1l"
                ></BaseInput>
              </div> -->
              <!-- <div class="mb-5 mt-10">
                <BaseInput placeholder=""  ref="company_settings__set_doc_predoplata"
                  input-name="company_settings__set_doc_predoplata" :value="dataSettings.company_settings__set_doc_predoplata" @onInput="updateValue"
                  :name-sign="dataLang?.company_settings__set_doc_predoplata"></BaseInput>
              </div> -->
              <!-- <div class="mb-5 mt-10">
                <BaseInput
                  placeholder=""

                  ref="company_settings__set_doc_shtraf"
                  input-name="company_settings__set_doc_shtraf"
                  :value="dataSettings.company_settings__set_doc_shtraf"
                  @onInput="updateValue"
                  :name-sign="dataLang?.company_settings__set_doc_shtraf"
                ></BaseInput>
              </div> -->

              <div
                class="tw-grid tw-grid-cols-[auto_60px] tw-mb-[15px] tw-max-w-[450px]"
              >
                <BaseCheckboxV2
                  signClass="!tw-text-[14px] !tw-text-forTitle"
                  ref="company_settings__set_doc_avtodelete_fl"
                  input-name="company_settings__set_doc_avtodelete_fl"
                  v-model="dataSettings.company_settings__set_doc_avtodelete_fl"
                  @oncheckeds="updateValue"
                >
                  {{ dataLang?.company_settings__set_doc_avtodelete_fl }}
                </BaseCheckboxV2>
                <BaseInput
                  inputClass="tw-app-input-type-3"
                  ref="company_settings__set_doc_avtodelete_fl_count"
                  input-name="company_settings__set_doc_avtodelete_fl_count"
                  :value="
                    dataSettings.company_settings__set_doc_avtodelete_fl_count
                  "
                  @onInput="updateValue"
                ></BaseInput>
              </div>

              <div class="tw-grid tw-grid-cols-[auto_60px] tw-max-w-[450px]">
                <BaseCheckboxV2
                  signClass="!tw-text-[14px] !tw-text-forTitle"
                  ref="company_settings__set_doc_avtodelete_ul"
                  input-name="company_settings__set_doc_avtodelete_ul"
                  v-model="dataSettings.company_settings__set_doc_avtodelete_ul"
                  @oncheckeds="updateValue"
                >
                  {{ dataLang?.company_settings__set_doc_avtodelete_ul }}
                </BaseCheckboxV2>
                <BaseInput
                  inputClass="tw-app-input-type-3"
                  ref="company_settings__set_doc_avtodelete_ul_count"
                  input-name="company_settings__set_doc_avtodelete_ul_count"
                  :value="
                    dataSettings.company_settings__set_doc_avtodelete_ul_count
                  "
                  @onInput="updateValue"
                ></BaseInput>
              </div>
            </div>

            <div
              class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px] tw-w-full"
            >
              <div
                class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[15px]"
              >
                {{ dataLang?.set_doc_group2 }}
              </div>

              <div class="tw-mb-[15px]">
                <div class="tw-app-input-type-3-label">
                  {{ dataLang?.company_settings__set_doc_premiya_n }}
                </div>
                <BaseInput
                  class="tw-w-[300px]"
                  inputClass="tw-app-input-type-3"
                  ref="company_settings__set_doc_premiya_n"
                  input-name="company_settings__set_doc_premiya_n"
                  :value="dataSettings.company_settings__set_doc_premiya_n"
                  @onInput="updateValue"
                ></BaseInput>
              </div>

              <div class="tw-mb-[15px]">
                <div class="tw-app-input-type-3-label">
                  {{ dataLang?.company_settings__set_doc_premiya_p }}
                </div>
                <BaseInput
                  class="tw-w-[300px]"
                  inputClass="tw-app-input-type-3"
                  ref="company_settings__set_doc_premiya_p"
                  input-name="company_settings__set_doc_premiya_p"
                  :value="dataSettings.company_settings__set_doc_premiya_p"
                  @onInput="updateValue"
                ></BaseInput>
              </div>

              <div class="tw-mb-[15px]">
                <div class="tw-app-input-type-3-label">
                  {{ dataLang?.company_settings__set_doc_premiya_strax }}
                </div>
                <BaseInput
                  class="tw-w-[300px]"
                  inputClass="tw-app-input-type-3"
                  ref="company_settings__set_doc_premiya_strax"
                  input-name="company_settings__set_doc_premiya_strax"
                  :value="dataSettings.company_settings__set_doc_premiya_strax"
                  @onInput="updateValue"
                ></BaseInput>
              </div>
            </div>
          </div>
        </v-tab>

        <v-tab title="Клиенты">
          <!-- <div class="block-action mt-20">
            <span class="fw-bold">{{ dataLang?.set_client_group1 }}</span>
            <div class="mb-5 mt-10">
              <BaseInput
                class="align-items-center flex-row gap-10 wp-15 white-space-pre"
                placeholder=""

                ref="company_settings__set_client_72hous"
                input-name="company_settings__set_client_72hous"
                :value="dataSettings.company_settings__set_client_72hous"
                @onInput="updateValue"
                :name-sign="dataLang?.company_settings__set_client_72hous"
              ></BaseInput>
            </div>

            <div class="mb-5 mt-10">
              <BaseInput
                class="align-items-center flex-row gap-10 wp-15 white-space-pre"
                placeholder=""

                ref="company_settings__set_client_168hous"
                input-name="company_settings__set_client_168hous"
                :value="dataSettings.company_settings__set_client_168hous"
                @onInput="updateValue"
                :name-sign="dataLang?.company_settings__set_client_168hous"
              ></BaseInput>
            </div>
          </div> -->
          <div
            class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px] tw-mt-[15px]"
          >
            <div>
              <div
                class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[8px]"
              >
                {{ dataLang?.company_settings__set_client_avto_delete }}
              </div>
              <BaseInput
                class="tw-w-[300px]"
                inputClass="tw-app-input-type-3"
                ref="company_settings__set_client_avto_delete"
                input-name="company_settings__set_client_avto_delete"
                :value="dataSettings.company_settings__set_client_avto_delete"
                @onInput="updateValue"
              ></BaseInput>
            </div>
          </div>

          <div
            class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
          >
            <div
              class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[15px]"
            >
              {{ dataLang?.set_client_group2 }}
            </div>
            <div class="tw-mb-[15px]">
              <div class="tw-app-input-type-3-label">
                {{ dataLang?.company_settings__set_client_days_last_doc }}
              </div>
              <BaseInput
                class="tw-w-[300px]"
                inputClass="tw-app-input-type-3"
                ref="company_settings__set_client_days_last_doc"
                input-name="company_settings__set_client_days_last_doc"
                :value="dataSettings.company_settings__set_client_days_last_doc"
                @onInput="updateValue"
              ></BaseInput>
            </div>
          </div>

          <div
            class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
          >
            <span
              class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[15px]"
            >
              {{ dataLang?.set_client_group3 }}
            </span>
            <div class="tw-mb-[15px]">
              <BaseCheckboxV2
                :disabled="
                  !!JSON.parse(
                    dataSettings.company_settings__set_client_is_avtoreset_verif
                  )
                "
                signClass="!tw-text-[14px] !tw-text-forTitle"
                ref="company_settings__set_client_is_avtoreset_verif"
                class="mt-20"
                input-name="company_settings__set_client_is_avtoreset_verif"
                v-model="
                  dataSettings.company_settings__set_client_is_avtoreset_verif
                "
                @oncheckeds="updateValue"
              >
                {{ dataLang?.company_settings__set_client_is_avtoreset_verif }}
              </BaseCheckboxV2>
            </div>

            <div class="tw-flex tw-gap-[10px] tw-items-center">
              <BaseCheckboxV2
                signClass="!tw-text-[14px] !tw-text-forTitle"
                ref="company_settings__set_client_is_intervalreset_verif"
                input-name="company_settings__set_client_is_intervalreset_verif"
                inputStyle="width: 100px"
                v-model="
                  dataSettings.company_settings__set_client_is_intervalreset_verif
                "
                @oncheckeds="updateValue"
              >
                {{
                  dataLang?.company_settings__set_client_is_intervalreset_verif
                }}
              </BaseCheckboxV2>
              <BaseInput
                class="tw-w-[100px]"
                inputClass="tw-app-input-type-3"
                ref="company_settings__verification_count_days"
                input-name="company_settings__verification_count_days"
                :value="dataSettings.company_settings__verification_count_days"
                @onInput="updateValue"
              ></BaseInput>
            </div>
          </div>
        </v-tab>

        <!-- <v-tab title="Заказы">
          <Development class="pt-20" :title="titleDevelopment"></Development>
        </v-tab> -->

        <v-tab title="Финансы">
          <div class="tw-w-[30%] tw-min-w-[560px] tw-pt-[15px]">
            <div
              class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
            >
              <div
                class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[15px]"
              >
                НДС в счетах
              </div>
              <div class="tw-mb-[10px]">
                <BaseRadio
                  signClass="!tw-text-[14px] !tw-text-forTitle"
                  inputName="company_settings__is_nds"
                  name="company_settings__is_nds"
                  value="0"
                  @change="updateValue"
                  v-model="dataSettings.company_settings__is_nds"
                >
                  Без НДС
                </BaseRadio>
              </div>
              <div class="tw-flex tw-gap-[10px] tw-items-center">
                <BaseRadio
                  signClass="!tw-text-[14px] !tw-text-forTitle"
                  inputName="company_settings__is_nds"
                  name="company_settings__is_nds"
                  value="1"
                  @change="updateValue"
                  v-model="dataSettings.company_settings__is_nds"
                >
                  НДС
                </BaseRadio>
                <div
                  class="tw-flex tw-gap-[5px] tw-items-center tw-text-[14px]"
                >
                  <BaseInput
                    inputClass="tw-app-input-type-3"
                    style="width: 100px"
                    ref="company_settings__nds_value"
                    input-name="company_settings__nds_value"
                    :value="dataSettings.company_settings__nds_value"
                    @onInput="updateValue"
                    name-sign=""
                  ></BaseInput
                  >%
                </div>
              </div>
            </div>

            <FundsSettings></FundsSettings>
            <div
              class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
            >
              <BaseCheckboxV2
                ref="is_allow_auto_send_money_from_balance_to_bank"
                input-name="is_allow_auto_send_money_from_balance_to_bank"
                v-model="
                  dataSettings.is_allow_auto_send_money_from_balance_to_bank
                "
                @oncheckeds="updateValue"
                class="align-items-start"
              >
                <span class="fsc-14"
                  >Разрешить автоматический перевод всех денег с баланса (за
                  минусом 5000) на мой расчетный счет каждый понедельник (если
                  эта галка отключена, вы выводите деньги с баланса на свой РС
                  только “ручными запросами” в 301 разделе)</span
                >
              </BaseCheckboxV2>
            </div>
          </div>
        </v-tab>

        <v-tab title="Транспорт">
          <div
            class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px] tw-mt-[15px]"
          >
            <div class="tw-mb-[15px]">
              <div class="tw-app-input-type-3-label">
                Актуализация пробега, суток от последнего обновления
              </div>
              <BaseInputNew
                class="tw-w-[300px]"
                inputClass="tw-app-input-type-3"
                :input-name="'company_settings__set_vehicle_upmileage'"
                @input="updateValue"
                input-name="company_settings__set_vehicle_upmileage"
                :value="dataSettings.company_settings__set_vehicle_upmileage"
              >
              </BaseInputNew>
              <div class="tw-text-[12px] tw-text-forText tw-mt-[2px]">
                Если в этом поле не будет цифры - не будет контроля актуальности
              </div>
            </div>

            <div class="tw-mb-[15px]">
              <div class="tw-app-input-type-3-label">
                Актуализация моточасов, суток от последнего обновления
              </div>
              <BaseInputNew
                class="tw-w-[300px]"
                inputClass="tw-app-input-type-3"
                :input-name="'company_settings__days_to_update_motohour'"
                @input="updateValue"
                input-name="company_settings__days_to_update_motohour"
                :value="dataSettings.company_settings__days_to_update_motohour"
              >
              </BaseInputNew>
              <div class="tw-text-[12px] tw-text-forText tw-mt-[2px]">
                Если в этом поле не будет цифры - не будет контроля актуальности
              </div>
            </div>
          </div>

          <div
            class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
          >
            <div class="tw-text-[15px] tw-text-forTitle tw-mb-[15px]">
              <span class="tw-font-semibold">Интервалы по умолчанию</span>
              (добавляются в каждый новый объект во вкладку интервалы)
            </div>

            <div class="tw-flex tw-gap-[10px] tw-mb-[15px]">
              <button
                class="tw-app-btn-primary-outline"
                @click="
                  () => {
                    isEditOpenedModalInterval = false;
                    inervalObjectForSend = {
                      company_interval_events__name: null,
                      company_interval_events__km: null,
                      company_interval_events__motohour: null,
                      company_interval_events__day: null,
                      company_interval_events__id: null,
                    };
                    $modal.show('intervalModal');
                  }
                "
              >
                <img
                  :src="require(`@/assets/icons/add.svg`)"
                  width="13.5"
                  height="13.5"
                />
                Добавить
              </button>
              <button
                class="tw-app-btn-primary-outline"
                style="padding-block: 8px"
                @click="
                  () =>
                    activeSelectRowsMultiple.length
                      ? $modal.show('deleteIntervalModal')
                      : $toast.error('Выберите хотя-бы одно поле')
                "
              >
                <img
                  :src="require(`@/assets/icons/minus-dark.svg`)"
                  width="13.5"
                  height="13.5"
                />
                Удалить
              </button>
            </div>

            <div class="overflow-auto_" style="min-height: 192px">
              <ve-table
                class="fixed-header rest-style-table"
                style="width: 100%"
                :columns="columns"
                :table-data="dataTable"
                :border-x="true"
                :border-y="true"
                row-key-field-name="company_interval_events__id"
                ref="mainTable"
                :eventCustomOption="eventCustomOption"
                :cell-style-option="cellStyleOption"
                :checkbox-option="{
                  selectedRowChange: selectedRowChange,
                  selectedAllChange: selectedAllChange,
                  hideSelectAll: false,
                }"
                :clickHighlight="false"
                :rowStyleOption="{
                  hoverHighlight: true,
                }"
                :cellSelectionOption="{ enable: false }"
              >
              </ve-table>
            </div>
          </div>
          <BaseModal
            name="intervalModal"
            width="420"
            :clickToClose="false"
            @before-close=""
            :shiftY="0.5"
            :adaptive="true"
            height="auto"
            classes="!tw-bg-transparent !tw-shadow-none"
          >
            <div
              class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-text-forTitle"
            >
              <button
                type="button"
                class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
                @click="$modal.hide('intervalModal')"
              ></button>

              <div class="tw-text-center">
                <div class="tw-text-[23px] tw-mb-[15px]">
                  Добавить/ Редактировать
                </div>

                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  class="tw-mb-[6px]"
                  :value="inervalObjectForSend.company_interval_events__name"
                  :width="'220'"
                  :horizontalTitle="true"
                  @input="
                    ({ value }) => {
                      inervalObjectForSend.company_interval_events__name =
                        value;
                    }
                  "
                  name-sign="Название"
                >
                </BaseInputNew>

                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  class="tw-mb-[6px]"
                  :value="inervalObjectForSend.company_interval_events__day"
                  :width="'220'"
                  :horizontalTitle="true"
                  @input="
                    ({ value }) => {
                      inervalObjectForSend.company_interval_events__day = value;
                    }
                  "
                  name-sign="Интервал дней"
                >
                </BaseInputNew>

                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  class="tw-mb-[6px]"
                  :value="inervalObjectForSend.company_interval_events__km"
                  :width="'220'"
                  :horizontalTitle="true"
                  @input="
                    ({ value }) => {
                      inervalObjectForSend.company_interval_events__km = value;
                    }
                  "
                  name-sign="Интервал пробега"
                >
                </BaseInputNew>

                <BaseInputNew
                  inputClass="tw-app-input-type-2"
                  class="tw-mb-[6px]"
                  :value="
                    inervalObjectForSend.company_interval_events__motohour
                  "
                  :width="'220'"
                  :horizontalTitle="true"
                  @input="
                    ({ value }) => {
                      inervalObjectForSend.company_interval_events__motohour =
                        value;
                    }
                  "
                  name-sign="Интервал моточасов"
                >
                </BaseInputNew>

                <div
                  class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center"
                >
                  <button
                    @click="$modal.hide('intervalModal')"
                    class="tw-app-btn-muted tw-app-btn-muted-lg"
                  >
                    Отменить
                  </button>
                  <button
                    @click="onSaveInterval"
                    class="tw-app-btn-primary tw-app-btn-primary-lg"
                  >
                    Сохранить
                  </button>
                </div>
              </div>
            </div>
          </BaseModal>

          <BaseModal
            name="deleteIntervalModal"
            width="420"
            :clickToClose="false"
            @before-close=""
            :shiftY="0.5"
            :adaptive="true"
            height="320"
            classes="!tw-bg-transparent !tw-shadow-none"
          >
            <div
              class="tw-bg-white tw-rounded-[25px] tw-py-[38px] tw-px-[30px] tw-relative tw-text-forTitle"
            >
              <button
                type="button"
                class="btn-close tw-absolute tw-right-[30px] tw-top-[20px] !tw-shadow-none"
                @click="$modal.hide('deleteIntervalModal')"
              ></button>
              <div class="tw-text-center">
                <div class="tw-text-[23px] tw-mb-[15px]">
                  Точно удалить запись?
                </div>

                <div
                  class="tw-flex tw-gap-[10px] tw-mt-[15px] tw-justify-center"
                >
                  <button
                    @click="$modal.hide('deleteIntervalModal')"
                    class="tw-app-btn-muted tw-app-btn-muted-lg"
                  >
                    Отменить
                  </button>
                  <button
                    @click="onDeleteInterval"
                    class="tw-app-btn-primary tw-app-btn-primary-lg"
                  >
                    Удалить
                  </button>
                </div>
              </div>
            </div>
          </BaseModal>

          <div
            class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
          >
            <div>
              <BaseCheckboxV2
                signClass="!tw-text-[14px] !tw-text-forTitle"
                ref="company_settings__set_vehicle_satatus_tire_rp"
                input-name="company_settings__set_vehicle_satatus_tire_rp"
                v-model="
                  dataSettings.company_settings__set_vehicle_satatus_tire_rp
                "
                @oncheckeds="updateValue"
              >
                <span class="">Сезоный шиномантаж</span>
              </BaseCheckboxV2>
            </div>

            <div
              v-if="dataSettings.company_settings__set_vehicle_satatus_tire_rp"
              class="tw-mb-[15px] tw-mt-[20px]"
            >
              <div class="tw-app-input-type-3-label">
                Дата смены на летнюю резину
              </div>
              <BaseDatePicker
                inputClass="tw-app-input-type-3"
                lang="ru"
                v-model="setVehicleSummerTireRpDate"
                alue-type="format"
                type="date"
                format="DD MMM"
                no-title
                popup-class="disabled-year"
                @change="
                  changeDate(
                    $event,
                    'company_settings__set_vehicle_summer_tire_rp_date'
                  )
                "
              ></BaseDatePicker>
            </div>

            <div
              v-if="dataSettings.company_settings__set_vehicle_satatus_tire_rp"
              class="tw-mb-[15px]"
            >
              <div class="tw-app-input-type-3-label">
                Дата смены на зимнюю резину
              </div>
              <BaseDatePicker
                inputClass="tw-app-input-type-3"
                popup-class="disabled-year"
                lang="ru"
                v-model="setVehicleWinterTireRpDate"
                alue-type="format"
                format="DD MMM"
                @change="
                  changeDate(
                    $event,
                    'company_settings__set_vehicle_winter_tire_rp_date'
                  )
                "
              ></BaseDatePicker>
            </div>
          </div>

          <div
            v-if="dataFromSetting"
            class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
          >
            <div
              class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[15px]"
            >
              Данные для входа на GELIOS (GPS)
            </div>
            <div class="tw-text-[14px]">
              <div>
                Логин: {{ dataSettings.company_settings__gelios_login }}
              </div>
              <div>
                Пароль: {{ dataSettings.company_settings__gelios_password }}
              </div>

              <div class="tw-mt-[15px] tw-text-forText">
                Для смены пароля обратитесь в поддержку
              </div>
            </div>

            <div class="tw-flex tw-gap-[10px] tw-mt-[15px]">
              <a
                href="https://play.google.com/store/apps/details?id=ru.soft.gelios.mobile&pli=1"
                target="_blank"
              >
                <img :src="require(`@/assets/GooglePlay.svg`)" alt="" />
              </a>
              <a
                href="https://apps.apple.com/ru/app/gelios/id999837601"
                target="_blank"
              >
                <img :src="require(`@/assets/AppStore.svg`)" alt="" />
              </a>
            </div>
          </div>
        </v-tab>

        <v-tab title="Безопасность">
          <div
            class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mt-[15px]"
          >
            <div>
              <!-- <div> -->
              <!-- <div class="block-action">
                  <div class="fw-bold mt-10">Тип входа в систему</div>
                  <div class="mb-5 mt-10">
                    <BaseRadio value="one-time" v-model="dataSettings.company_settings__set_security_type_password" input-name="company_settings__set_security_type_password">
                      Разовый пароль
                    </BaseRadio>
                  </div>
                  <div class="mb-5 mt-10">
                    <BaseRadio value="static" v-model="dataSettings.company_settings__set_security_type_password" input-name="company_settings__set_security_type_password">
                      Постоянный пароль
                    </BaseRadio>
                  </div>
                </div> -->
              <div class="tw-app-input-type-3-label">
                Пароль на все операции под замком
              </div>
              <div class="mb-5 mt-10">
                <BaseInput
                  class="tw-w-[300px]"
                  inputClass="tw-app-input-type-3"
                  ref="company_settings__set_security_pass_for_forbidden"
                  input-name="company_settings__set_security_pass_for_forbidden"
                  :value="
                    dataSettings.company_settings__set_security_pass_for_forbidden
                  "
                  @onInput="updateValue"
                ></BaseInput>
              </div>
            </div>
          </div>
          <!-- <div class="block-action mt-20">
            <div class="fw-bold mt-10">
              Выбор службы безопасности для проверок клиентов
            </div>
            <div class="mb-5 mt-10">
              <BaseRadio
                inputName="company_settings__type_security"
                name="company_settings__type_security"
                :value="'yandexrent_security_client'"
                @change="updateValue"
                v-model="dataSettings.company_settings__type_security"
              >
                СБ 1 (SIRIUS)
              </BaseRadio>
            </div>
            <div class="mb-5 mt-10">
              <BaseRadio
                inputName="company_settings__type_security"
                name="company_settings__type_security"
                :value="'base_security_client'"
                @change="updateValue"
                v-model="dataSettings.company_settings__type_security"
              >
                СБ 2 (ВНУТРЕННЯЯ)
              </BaseRadio>

              это было закоментированно
               <BaseRadio
                  :value="2"
                  class="mb-5"
                  signClass="fsc-11"
                  v-model="dataForModal.vehicles__rent_sgt"
                  input-name="vehicles__rent_sgt"
                  @change="updateValue"
                  >{{ dataLang['register_objects_car_text_33'] }}</BaseRadio
                >
            </div>
          </div> -->
        </v-tab>

        <v-tab title="SMS">
          <div
            class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px] tw-mt-[15px]"
          >
            <div
              class="tw-text-[15px] tw-text-forTitle tw-font-semibold tw-mb-[15px]"
            >
              SMS оповещения
            </div>

            <div class="tw-mb-[15px]">
              <BaseCheckboxV2
                signClass="!tw-text-[14px] !tw-text-forTitle"
                ref="company_settings__is_allowed_send_sms"
                input-name="company_settings__is_allowed_send_sms"
                v-model="dataSettings.company_settings__is_allowed_send_sms"
                @oncheckeds="updateValue"
              >
                SMS сервис (для всех разделов платформы)
              </BaseCheckboxV2>
              <div
                class="tw-text-[12px] tw-text-forText tw-mt-[2px] tw-ml-[34px]"
              >
                Включите, чтобы Сириус отправлял SMS на всех рабочих циклах
                (заказы, договоры аренды, проверки СБ, предупреждения о
                блокировке и отрицательном балансе, а также десятки других
                событий на платформе)
              </div>
            </div>

            <div
              v-if="
                JSON.parse(dataSettings.company_settings__is_allowed_send_sms)
              "
              class="tw-text-forTitle tw-mb-[15px] tw-text-[14px] tw-bg-[#e3f0ff] tw-p-[7px_15px] tw-rounded-[3px] tw-text-forText tw-mt-[15px]"
            >
              Стоимость 1 SMS = {{ aboutUser.sms_cost }} руб/шт (до
              {{ aboutUser.sms_length }} символов). Списывается с баланса.
            </div>

            <div
              v-if="
                JSON.parse(dataSettings.company_settings__is_allowed_send_sms)
              "
              class="tw-text-[14px] tw-bg-danger tw-text-white tw-rounded-[6px] tw-px-[15px] tw-py-[10px] tw-mb-[15px]"
            >
              Уважаемые пользователи!<br />
              Стоимость SMS для бизнеса устанавливают российские сотовые
              операторы (у всех одинаковый прайс). После окончательной
              блокировки всех иностранных мессенджеров, SMS стали единственным
              гарантированным каналом оповещения (тг,ватсап - больше нет, а
              роботизированный звонок могут пропустить). Сотовые операторы
              быстро поняли, что у них монополия на оповещение и подняли цены в
              10 раз (до ухода мессенджеров цены были от 4,8 до 7,2 руб за одно
              SMS). Мы понимаем, что цены высокие и ежедневно ищем решение этой
              проблемы.
            </div>

            <!-- смс настройки -->
            <div :id="keyCounter">
              <div v-if="dataSettings.company_settings__is_allowed_send_sms">
                <div
                  class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
                >
                  <div>
                    <BaseCheckboxV2
                      signClass="!tw-text-[14px] !tw-text-forTitle"
                      ref="company_settings__set_client_sms_negative_balans"
                      input-name="company_settings__set_client_sms_negative_balans"
                      v-model="
                        dataSettings.company_settings__set_client_sms_negative_balans
                      "
                      @oncheckeds="updateValue"
                      >{{
                        dataLang?.company_settings__set_client_sms_negative_balans
                      }}
                    </BaseCheckboxV2>
                  </div>

                  <div
                    v-if="
                      JSON.parse(
                        dataSettings.company_settings__set_client_sms_negative_balans
                      )
                    "
                    class="tw-mt-[15px]"
                  >
                    <div class="tw-mb-[15px]">
                      <div class="tw-app-input-type-3-label">
                        {{
                          dataLang[
                            "company_settings__set_client_sms_negative_balans_text"
                          ]
                        }}
                        ({{
                          countersList
                            .company_settings__set_client_sms_negative_balans_text
                            .length
                        }}
                        символа,
                        {{
                          Math.ceil(
                            countersList
                              .company_settings__set_client_sms_negative_balans_text
                              .length / 70
                          )
                        }}
                        SMS)
                      </div>
                      <BaseInput
                        inputClass="tw-app-input-type-3"
                        ref="company_settings__set_client_sms_negative_balans_text"
                        input-name="company_settings__set_client_sms_negative_balans_text"
                        :value="
                          dataSettings.company_settings__set_client_sms_negative_balans_text
                        "
                        @onInput="updateValue"
                      >
                      </BaseInput>
                    </div>

                    <div class="tw-mb-[15px]">
                      <div class="tw-app-input-type-3-label">
                        {{
                          dataLang?.company_settings__set_client_sms_negative_balans_povtory
                        }}
                      </div>
                      <BaseInput
                        class="tw-w-[100px]"
                        inputClass="tw-app-input-type-3"
                        ref="company_settings__set_client_sms_negative_balans_povtory"
                        input-name="company_settings__set_client_sms_negative_balans_povtory"
                        :value="
                          dataSettings.company_settings__set_client_sms_negative_balans_povtory
                        "
                        @onInput="updateValue"
                      ></BaseInput>
                    </div>

                    <div class="tw-mb-[15px]">
                      <div class="tw-app-input-type-3-label">
                        {{
                          dataLang[
                            "company_settings__set_client_sms_negative_balans_time"
                          ]
                        }}
                      </div>
                      <BaseDatePicker
                        class="!tw-w-[100px]"
                        inputClass="tw-app-input-type-3"
                        v-model="
                          dateList.company_settings__set_client_sms_negative_balans_time
                        "
                        type="time"
                        lang="ru"
                        value-type="format"
                        :time-title-format="userSetting.company__tempalte_date"
                        :format="`HH:mm`"
                        @change="
                          changeDate(
                            $event,
                            'company_settings__set_client_sms_negative_balans_time'
                          )
                        "
                      ></BaseDatePicker>
                      <!-- <BaseInput
                      placeholder=""

                      ref="company_settings__set_client_sms_negative_balans_time"
                      input-name="company_settings__set_client_sms_negative_balans_time"
                      :value="
                        dataSettings.company_settings__set_client_sms_negative_balans_time
                      "
                      @onInput="updateValue"
                      :name-sign="
                        dataLang?.company_settings__set_client_sms_negative_balans_time
                      "
                    ></BaseInput> -->
                    </div>
                  </div>
                </div>

                <div
                  class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
                >
                  <div>
                    <BaseCheckboxV2
                      signClass="!tw-text-[14px] !tw-text-forTitle"
                      ref="company_settings__set_client_sms_over_doc"
                      input-name="company_settings__set_client_sms_over_doc"
                      v-model="
                        dataSettings.company_settings__set_client_sms_over_doc
                      "
                      @oncheckeds="updateValue"
                    >
                      {{ dataLang?.company_settings__set_client_sms_over_doc }}
                    </BaseCheckboxV2>
                  </div>
                  <div
                    v-if="
                      JSON.parse(
                        dataSettings.company_settings__set_client_sms_over_doc
                      )
                    "
                    class="tw-mt-[15px]"
                  >
                    <div class="tw-mb-[15px]">
                      <div class="tw-app-input-type-3-label">
                        {{
                          dataLang[
                            "company_settings__set_client_sms_over_doc_text"
                          ]
                        }}
                        ({{
                          countersList
                            .company_settings__set_client_sms_over_doc_text
                            .length
                        }}
                        символа,
                        {{
                          Math.ceil(
                            countersList
                              .company_settings__set_client_sms_over_doc_text
                              .length / 70
                          )
                        }}
                        SMS)
                      </div>
                      <BaseInput
                        inputClass="tw-app-input-type-3"
                        ref="company_settings__set_client_sms_over_doc_text"
                        input-name="company_settings__set_client_sms_over_doc_text"
                        :value="
                          dataSettings.company_settings__set_client_sms_over_doc_text
                        "
                        @onInput="updateValue"
                      >
                      </BaseInput>
                    </div>

                    <div class="tw-mb-[15px]">
                      <div class="tw-app-input-type-3-label">
                        {{
                          dataLang?.company_settings__set_client_sms_over_doc_interval
                        }}
                      </div>
                      <BaseInput
                        class="tw-w-[100px]"
                        inputClass="tw-app-input-type-3"
                        ref="company_settings__set_client_sms_over_doc_interval"
                        input-name="company_settings__set_client_sms_over_doc_interval"
                        :value="
                          dataSettings.company_settings__set_client_sms_over_doc_interval
                        "
                        @onInput="updateValue"
                      ></BaseInput>
                    </div>

                    <div class="tw-mb-[15px]">
                      <div class="tw-app-input-type-3-label">
                        {{
                          dataLang[
                            "company_settings__set_client_sms_over_doc_time"
                          ]
                        }}
                      </div>
                      <BaseDatePicker
                        class="!tw-w-[100px]"
                        inputClass="tw-app-input-type-3"
                        v-model="
                          dateList.company_settings__set_client_sms_over_doc_time
                        "
                        type="time"
                        lang="ru"
                        value-type="format"
                        :time-title-format="userSetting.company__tempalte_date"
                        :format="`HH:mm`"
                        @change="
                          changeDate(
                            $event,
                            'company_settings__set_client_sms_over_doc_time'
                          )
                        "
                      ></BaseDatePicker>
                      <!-- <BaseInput
                      placeholder=""

                      ref="company_settings__set_client_sms_over_doc_time"
                      input-name="company_settings__set_client_sms_over_doc_time"
                      :value="
                        dataSettings.company_settings__set_client_sms_over_doc_time
                      "
                      @onInput="updateValue"
                      :name-sign="
                        dataLang?.company_settings__set_client_sms_over_doc_time
                      "
                    ></BaseInput> -->
                    </div>
                  </div>
                </div>

                <div
                  class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
                >
                  <div>
                    <BaseCheckboxV2
                      signClass="!tw-text-[14px] !tw-text-forTitle"
                      ref="company_settings__set_client_sms_dr"
                      input-name="company_settings__set_client_sms_dr"
                      v-model="dataSettings.company_settings__set_client_sms_dr"
                      @oncheckeds="updateValue"
                    >
                      {{ dataLang?.company_settings__set_client_sms_dr }}
                    </BaseCheckboxV2>
                  </div>

                  <div
                    v-if="
                      JSON.parse(
                        dataSettings.company_settings__set_client_sms_dr
                      )
                    "
                    class="tw-mt-[15px]"
                  >
                    <div class="tw-mb-[15px]">
                      <div class="tw-app-input-type-3-label">
                        {{
                          dataLang["company_settings__set_client_sms_dr_text"]
                        }}
                        ({{
                          countersList.company_settings__set_client_sms_dr_text
                            .length
                        }}
                        символа,
                        {{
                          Math.ceil(
                            countersList
                              .company_settings__set_client_sms_dr_text.length /
                              70
                          )
                        }}
                        SMS)
                      </div>
                      <BaseInput
                        inputClass="tw-app-input-type-3"
                        ref="company_settings__set_client_sms_dr_text"
                        input-name="company_settings__set_client_sms_dr_text"
                        :value="
                          dataSettings.company_settings__set_client_sms_dr_text
                        "
                        @onInput="updateValue"
                      >
                      </BaseInput>
                    </div>

                    <div class="tw-mb-[15px]">
                      <div class="tw-app-input-type-3-label">
                        {{
                          dataLang[
                            "company_settings__set_client_sms_over_doc_time"
                          ]
                        }}
                      </div>
                      <BaseDatePicker
                        class="!tw-w-[100px]"
                        inputClass="tw-app-input-type-3"
                        v-model="
                          dateList.company_settings__set_client_sms_dr_time
                        "
                        type="time"
                        lang="ru"
                        value-type="format"
                        :time-title-format="userSetting.company__tempalte_date"
                        :format="`HH:mm`"
                        @change="
                          changeDate(
                            $event,
                            'company_settings__set_client_sms_dr_time'
                          )
                        "
                      ></BaseDatePicker>
                      <!-- <BaseInput
                      placeholder=""

                      ref="company_settings__set_client_sms_dr_time"
                      input-name="company_settings__set_client_sms_dr_time"
                      :value="dataSettings.company_settings__set_client_sms_dr_time"
                      @onInput="updateValue"
                      :name-sign="dataLang?.company_settings__set_client_sms_dr_time"
                    ></BaseInput> -->
                    </div>
                  </div>
                </div>

                <div
                  class="tw-bg-white tw-rounded-[6px] tw-border-solid tw-border-[1px] tw-border-forLine tw-p-[15px] tw-mb-[15px]"
                >
                  <div>
                    <BaseCheckboxV2
                      signClass="!tw-text-[14px] !tw-text-forTitle"
                      ref="company_settings__set_client_sms_dr7"
                      input-name="company_settings__set_client_sms_dr7"
                      v-model="
                        dataSettings.company_settings__set_client_sms_dr7
                      "
                      @oncheckeds="updateValue"
                    >
                      {{ dataLang?.company_settings__set_client_sms_dr7 }}
                    </BaseCheckboxV2>
                  </div>

                  <div
                    v-if="
                      JSON.parse(
                        dataSettings.company_settings__set_client_sms_dr7
                      )
                    "
                    class="tw-mt-[15px]"
                  >
                    <div class="tw-mb-[15px]">
                      <div class="tw-app-input-type-3-label">
                        {{
                          dataLang["company_settings__set_client_sms_dr7_text"]
                        }}
                        ({{
                          countersList.company_settings__set_client_sms_dr7_text
                            .length
                        }}
                        символа,
                        {{
                          Math.ceil(
                            countersList
                              .company_settings__set_client_sms_dr7_text
                              .length / 70
                          )
                        }}
                        SMS)
                      </div>
                      <BaseInput
                        inputClass="tw-app-input-type-3"
                        ref="company_settings__set_client_sms_dr7_text"
                        input-name="company_settings__set_client_sms_dr7_text"
                        :value="
                          dataSettings.company_settings__set_client_sms_dr7_text
                        "
                        @onInput="updateValue"
                      >
                      </BaseInput>
                    </div>

                    <div class="tw-mb-[15px]">
                      <div class="tw-app-input-type-3-label">
                        {{
                          dataLang["company_settings__set_client_sms_dr7_time"]
                        }}
                      </div>
                      <BaseDatePicker
                        class="!tw-w-[100px]"
                        inputClass="tw-app-input-type-3"
                        v-model="
                          dateList.company_settings__set_client_sms_dr7_time
                        "
                        type="time"
                        lang="ru"
                        value-type="format"
                        :time-title-format="userSetting.company__tempalte_date"
                        :format="`HH:mm`"
                        @change="
                          changeDate(
                            $event,
                            'company_settings__set_client_sms_dr7_time'
                          )
                        "
                      ></BaseDatePicker>
                      <!-- <BaseInput
                      placeholder=""

                      ref="company_settings__set_client_sms_dr7_time"
                      input-name="company_settings__set_client_sms_dr7_time"
                      :value="dataSettings.company_settings__set_client_sms_dr7_time"
                      @onInput="updateValue"
                      :name-sign="dataLang?.company_settings__set_client_sms_dr7_time"
                    ></BaseInput> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-tab>
      </vue-tabs>
    </div>
  </div>
</template>

<script>
import ModalAll from "@/components/ModalAll.vue";
import BaseInput from "@/components/ui/BaseInput.vue";
import FundsSettings from "@/components/global_settings/FundsSettings.vue";
import SecureSBGroupsSettings from "@/components/global_settings/SecureSBGroupsSettings.vue";
import TheTimeline from "@/components/TheTimeline.vue";
import LineChart from "@/components/Chart.vue";
import Development from "@/components/Development.vue";
import ImageUploadPreview from "@/components/ImageUploadPreview.vue";
import StorageFileService from "@/api/StorageFileService.js";
import { VueTabs, VTab } from "vue-nav-tabs/dist/vue-tabs.js";
import { VeTable } from "vue-easytable";
import { mapActions, mapState, mapMutations } from "vuex";
import BaseCheckboxV2 from "@/components/ui/BaseCheckboxV2.vue";
import GeneralService from "@/api/GeneralService";
export default {
  components: {
    BaseInput,
    TheTimeline,
    ModalAll,
    LineChart,
    ImageUploadPreview,
    VueTabs,
    VTab,
    VeTable,
    Development,
    BaseCheckboxV2,
    FundsSettings,
    SecureSBGroupsSettings,
  },

  props: {},
  data() {
    return {
      keyCounter: 0,
      allCities: [],
      dataTable: [],
      inervalObjectForSend: {
        company_interval_events__name: null,
        company_interval_events__km: null,
        company_interval_events__motohour: null,
        company_interval_events__day: null,
        company_interval_events__id: null,
      },
      dataFromSetting: {},
      countersList: {
        company_settings__set_client_sms_negative_balans_text: "",
        company_settings__set_client_sms_over_doc_text: "",
        company_settings__set_client_sms_dr_text: "",
        company_settings__set_client_sms_dr7_text: "",
      },
      dateList: {
        company_settings__set_client_sms_negative_balans_time: "",
        company_settings__set_client_sms_over_doc_time: "",
        company_settings__set_client_sms_dr_time: "",
        company_settings__set_client_sms_dr7_time: "",
      },
      updatedValues: {},
      timeout: null,
      activeSelectRowsMultiple: [],
      monthSelectOption: [],
      daySelectOption: [],
      selectsData: { cities: [], region: [] },
      selectsValue: { cities: [], region: [] },
      settingsAreaWithInnConfirmed: {},
      isEditOpenedModalInterval: false,
      titleDevelopment: "Раздел будет разработан в скором времени...",
      eventCustomOption: {
        bodyRowEvents: ({ row, rowIndex }) => {
          return {
            dblclick: (event) => {
              this.inervalObjectForSend = Object.assign(
                this.inervalObjectForSend,
                row
              );
              this.isEditOpenedModalInterval = true;
              this.$modal.show("intervalModal");
            },
          };
        },
      },
      cellStyleOption: {},
    };
  },

  methods: {
    onDeleteInterval() {
      if (this.activeSelectRowsMultiple.length) {
        GeneralService.delete(
          `/company_interval_events/${this.activeSelectRowsMultiple}`
        )
          .then((data) => {
            this.$toast.success(data.data.message, { duration: 5000 });
          })
          .catch((e) => {
            this.$toast.error(e.response.data.message, { duration: 5000 });
          })
          .finally(() => {
            this.activeSelectRowsMultiple = [];
            this.$modal.hide("deleteIntervalModal");
            this.loadIntervals();
          });
      }
    },
    onSaveInterval() {
      if (this.isEditOpenedModalInterval) {
        GeneralService.edit(
          `/company_interval_events/${this.inervalObjectForSend.company_interval_events__id}`,
          this.inervalObjectForSend
        )
          .then((data) => {
            this.inervalObjectForSend = {
              company_interval_events__name: null,
              company_interval_events__km: null,
              company_interval_events__motohour: null,
              company_interval_events__day: null,
              company_interval_events__id: null,
            };
            this.$toast.success(data.data.message, { duration: 5000 });
            this.$modal.hide("intervalModal");
            this.loadIntervals();
          })
          .catch((e) => {
            if (e.response.data) {
              this.$toast.error(e.response.data.message, { duration: 5000 });
            }
          });
      } else {
        GeneralService.editOrCreate(
          `/company_interval_events`,
          this.inervalObjectForSend
        )
          .then((data) => {
            this.inervalObjectForSend = {
              company_interval_events__name: null,
              company_interval_events__km: null,
              company_interval_events__motohour: null,
              company_interval_events__day: null,
              company_interval_events__id: null,
            };
            this.$toast.success(data.data.message, { duration: 5000 });
            this.$modal.hide("intervalModal");
            this.loadIntervals();
          })
          .catch((e) => {
            if (e.response.data) {
              this.$toast.error(e.response.data.message, { duration: 5000 });
            }
          });
      }
    },
    loadIntervals() {
      GeneralService.get(`/company_interval_events`)
        .then((data) => {
          this.dataTable = data.data.data.rows;
        })
        .catch((e) => {
          this.$toast.error("Неизвестная ошибка при загрузке таблицы", {
            duration: 5000,
          });
        });
    },
    selectedRowChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    selectedAllChange({ row, isSelected, selectedRowKeys }) {
      this.activeSelectRowsMultiple = selectedRowKeys;
    },
    async onCopy(text) {
      if (!navigator.clipboard) {
        console.error("Буфер обмена недоступен в этом браузере.");
        return;
      }
      try {
        await navigator.clipboard.writeText(text);
        this.$toast.info("Ссылка скопирована");
      } catch (err) {
        this.$toast.error("Ошибка при копировании текста", { duration: 5000 });
      }
    },
    changeCityAndRegion(datas) {
      GeneralService.edit("/super/companies/settings/bank_details", {
        ...datas,
      })
        .then((data) => {
          if (datas?.companies__region_id) {
            this.selectsValue.cities = [];
            // this.selectsData.cities = this.selectsData.cities.filter((x) => x.cities__region_id == datas.companies__region_id)
            // this.getCities(datas.companies__region_id)
          }
          this.$toast.success(data.data.message);
          // this.updateUserStatus({ company_status: 'company_status_requested' })
        })
        .catch((err) => {
          if (err.response) {
            this.$toast.error(err.response.data.message, { duration: 5000 });
          } else {
            console.error(err);
          }
        });
    },
    changeDate(date, name) {
      if (!date) date = "";
      this.updateValue({ name: name, value: date });
    },
    uploadFile(e, key) {
      let formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("type", "default");
      StorageFileService.upload(formData)
        .then((data) => {
          this.update_setting({ key: key, value: data.data.data.url });
          this.updateValue({ name: key, value: data.data.data.id }, "file");
        })
        .catch((err) => {
          throw new Error(err);
        });
    },

    delFile(name, file) {
      // this.dataSettings[name] = null
      this.update_setting({ key: name, value: null });
      this.updateValue({ name: name, value: "" });
    },
    ...mapMutations("globalSettingModule", ["update_setting"]),
    ...mapActions("globalSettingModule", ["getAll", "updateSettings"]),

    updateValue(data, file) {
      if (data.name in this.countersList) {
        this.countersList[data.name] = data.value;
      }
      this.updatedValues[data.name] = data.value;
      if (!file) {
        this.dataSettings[data.name] = data.value;
      }

      this.keyCounter++;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(this.requestToPath, 2000);
    },
    requestToPath() {
      this.updateSettings(this.updatedValues);
      this.updatedValues = {};
    },

    getCities(id) {
      GeneralService.get(`/cities`, {
        params: {
          where: JSON.stringify([{ field: "cities__region_id", value: id }]),
        },
      }).then((data) => {
        this.selectsData.cities = data.data.data.rows;
      });
    },

    changeCompanyStatus() {
      GeneralService.edit("/super/companies/settings/bank_details", {
        companies__status: true,
      })
        .then((data) => {
          console.log(data);
          this.updateUserStatus({ company_status: "company_status_requested" });
        })
        .catch((err) => {
          if (err.response) {
            this.$toast.error(err.response.data.message, { duration: 5000 });
          } else {
            console.error(err);
          }
        });
    },

    selectOptionsUTC() {
      let options = [];
      for (let i = -12; i <= 12; i++) {
        if (i > 0) i = "+" + i;
        else i = i + "";
        options.push(i);
      }

      return options;
    },
    // debounce(data, callback, delay) {
    //   let timeout;
    //   return function () {
    //     clearTimeout(timeout);
    //     timeout = setTimeout(callback, delay);
    //   }
    // }
    ...mapActions("userSettingModule", ["updateUserStatus"]),
    ...mapActions("aboutUserModule", ["getAboutUser"]),
  },

  created() {
    this.getAboutUser();
  },
  mounted() {
    this.$root.$i18n.locale = "en";
    this.getAll({
      callback: (data) => {
        Object.assign(this.dateList, data);
        for (const key in data) {
          if (key in this.countersList && data[key] !== null) {
            this.countersList[key] = data[key];
          }
        }
      },
    });

    GeneralService.get("/super/settings")
      .then((data) => {
        data.data.data.rows.forEach((element) => {
          this.dataFromSetting[element.company_settings_super__setting_key] = {
            ...element,
          };
        });
      })
      .catch((err) => {});

    this.loadIntervals();

    Promise.all([
      GeneralService.get("/super/companies/settings/bank_details").then(
        (data) => {
          this.settingsAreaWithInnConfirmed = data.data.data;
        }
      ),
      GeneralService.get(`/cities`, {
        params: {
          limit: 5000,
        },
      }).then((data) => {
        this.allCities = data.data.data.rows;
      }),
      GeneralService.get("/regions", {
        params: {
          limit: 5000,
        },
      }).then((data) => {
        this.selectsData.region = data.data.data.rows;
      }),
    ])
      .then(() => {
        this.selectsValue.cities = this.allCities.find((x) => {
          return (
            x.cities__id == this.settingsAreaWithInnConfirmed.companies__city_id
          );
        });
        this.selectsValue.region = this.selectsData.region.find((x) => {
          return (
            x.regions__id ==
            this.settingsAreaWithInnConfirmed.companies__region_id
          );
        });
      })
      .catch((err) => {
        if (err.response) {
          this.$toast.error(err.response.data.message, { duration: 5000 });
        } else {
          console.error(err);
        }
      });
  },
  computed: {
    ...mapState("globalSettingModule", ["dataSettings", "loadStatus"]),
    ...mapState("translationModule", ["dataLang"]),
    ...mapState("userSettingModule", ["userSetting", "loadUserSetting"]),
    ...mapState("aboutUserModule", ["aboutUser"]),

    SeniorManagementReportsAndAlerts() {
      return [
        {
          value: "company_settings__emails_1",
          title: "company_setting_4",
        },
        {
          value: "company_settings__emails_2",
          title: "company_setting_5",
        },
        {
          value: "company_settings__emails_3",
          title: "company_setting_6",
        },
        {
          value: "company_settings__emails_4",
          title: "company_setting_7",
        },
        {
          value: "company_settings__emails_5",
          title: "Директор по продажам",
        },
        {
          value: "company_settings__emails_6",
          title: "company_setting_8",
        },
        {
          value: "company_settings__emails_7",
          title: "company_setting_9",
        },
        {
          value: "company_settings__emails_8",
          title: "company_setting_10",
        },
        {
          value: "company_settings__emails_9",
          title: "company_setting_11",
        },
        // {
        //   value: "company_settings__emails_10",
        //   title: "company_setting_12",
        // },
        // {
        //   value: "company_settings__emails_11",
        //   title: "company_setting_13",
        // },
        // {
        //   value: "company_settings__emails_12",
        //   title: "company_setting_18",
        // },
        // {
        //   value: "company_settings__emails_13",
        //   title: "company_setting_14",
        // },
        // {
        //   value: "company_settings__emails_14",
        //   title: "company_setting_15",
        // },
        {
          value: "company_settings__emails_15",
          title: "company_setting_16",
        },
        {
          value: "company_settings__emails_16",
          title: "company_setting_17",
        },
      ];
    },

    columns() {
      return [
        {
          field: "",
          key: "a62",
          type: "checkbox",
          title: "",
          width: "2%",
          align: "center",
        },
        {
          field: "company_interval_events__name",
          key: "765765",
          title: "Название",
          align: "center",
          width: "24.5%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "company_interval_events__day",
          key: "46565",
          title: "Интервал дней",
          align: "center",
          width: "24.5%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "company_interval_events__km",
          key: "35612",
          title: "Интервал пробега",
          align: "center",
          width: "24.5%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
        {
          field: "company_interval_events__motohour",
          key: "142436",
          title: "Интервал моточасов",
          align: "center",
          width: "24.5%",
          ellipsis: {
            showTitle: true,
            lineClamp: 1,
          },
        },
      ];
    },

    setVehicleSummerTireRpDate: {
      get() {
        if (this.dataSettings.company_settings__set_vehicle_summer_tire_rp_date)
          return new Date(
            this.dataSettings.company_settings__set_vehicle_summer_tire_rp_date
          );
        return "";
      },

      set(v) {
        if (!v) v = "";
        this.update_setting({
          key: "company_settings__set_vehicle_summer_tire_rp_date",
          value: v,
        });
      },
    },

    setVehicleWinterTireRpDate: {
      get() {
        if (this.dataSettings.company_settings__set_vehicle_winter_tire_rp_date)
          return new Date(
            this.dataSettings.company_settings__set_vehicle_winter_tire_rp_date
          );
        return "";
      },

      set(v) {
        if (!v) v = "";
        this.update_setting({
          key: "company_settings__set_vehicle_winter_tire_rp_date",
          value: v,
        });
      },
    },

    selectedOptionUTC: {
      get() {
        return this.dataSettings.company_settings__set_req_uts;
      },

      set(v) {
        if (!v) v = "";
        this.update_setting({ key: "company_settings__set_req_uts", value: v });
        this.updateValue({ name: "company_settings__set_req_uts", value: v });
      },
    },

    cityOptions() {
      return (
        this.allCities.filter(
          (c) => c.cities__region_id === this.selectsValue.region?.regions__id
        ) ?? []
      );
    },
  },
};
</script>

<style lang="scss" scoped>
// .mx-btn-current-year {
//         display: none !important;
//       }

// .mx-btn-current-year {
//     display: none !important;
//   }
// .mx-btn-icon-double-right,
// .mx-btn-icon-double-left {
//     display: none !important;
//   }

// .mx-calendar-panel-month .mx-calendar-header {
//     display: none !important;
//   }
</style>
